export enum MessagesEnum {
  acceptContactRequest = "Tem certeza que deseja partilhar o seu contacto com o usuario solicitante?",
  rejectContactRequest = "Tem certeza que deseja rejeitar o pedido, o solicitante tera de fazer outro pedido caso rejeite?"
}
